export type MynazcaLang = 'ja' | 'en';

type CopyPair = { ja: string; en: string };

export function mynazcaT(pair: CopyPair, lang: MynazcaLang): string {
  return lang === 'ja' ? pair.ja : pair.en;
}

/** Step 2: route creation (desktop + mobile) */
export const mynazcaRouteCopy = {
  sectionTitle: {
    ja: 'ルートを作る',
    en: 'Create route',
  },
  sectionHint: {
    ja: '画像の種類に合わせてモードを選んでください。',
    en: 'Select a mode that matches your image type.',
  },
  previewEmpty: {
    ja: '「ルートを作成」で生成します。',
    en: 'Click "Create route" to generate.',
  },
  previewPanelTitle: {
    ja: 'ルートプレビュー',
    en: 'Route preview',
  },
  createButton: {
    ja: 'ルートを作成',
    en: 'Create route',
  },
  tablistLabel: {
    ja: 'ルート作成モード',
    en: 'Route creation mode',
  },
  modeLine: {
    ja: '線画',
    en: 'Line',
  },
  modePhoto: {
    ja: '写真',
    en: 'Photo',
  },
} as const satisfies Record<string, CopyPair>;
